import { DisplayPosition } from '@/type/display-position';
import { condition, handleSelectDataSource, handleSelectRequestConfig, } from '../../util/util';
import { __tableCurrentRow__ } from '../../util/expr-const';
import { getDataOriginSetterSnippet, getRequestConfigSetterSnippet, getRequestWhenFocusSetterSnippet, getSearchRemoteSetterSnippet, getSelectModeSetterSnippet, getStaticDataSourceSnippet, } from '../setter-snippet';
import isPlainObject from 'lodash/isPlainObject';
const { CnTooltip } = window.CNUI || {};
export function getSelectParamSelectSetter(config) {
    const { position } = config || {};
    let paramSelectSetter = {
        componentName: 'ParamSelectSetter',
        props: {
            dataKey: 'config',
            labelKey: 'label',
            valueKey: 'name',
            groupName: '参数列表',
        },
        title: '选择参数',
    };
    if (position === DisplayPosition.cnArrayTable) {
        paramSelectSetter = {
            componentName: 'ParamSelectSetter',
            props: {
                dataKey: 'arrayTable',
                labelKey: 'label',
                valueKey: 'name',
                groupName: '表格当前行数据',
                groupExprName: __tableCurrentRow__,
            },
            title: '选择参数',
        };
    }
    return paramSelectSetter;
}
const Select = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '下拉选择',
    componentName: 'CnAsyncSelect',
    // component: CnAsyncSelect,
    // formComponent: formComponentMap.CnAsyncSelect,
    getDefaultProps: () => {
        return {
            dataOrigin: 'request',
            mode: 'single',
        };
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
        const componentProps = formItem?.['x-component-props'];
        if (isPlainObject(componentProps)) {
            const { manual } = componentProps;
            if (manual === true && componentProps?.requestConfig) {
                componentProps.requestConfig.manual = true;
            }
        }
    },
    // select的prototype列表
    getPrototypeList: (position) => {
        return [
            getSelectModeSetterSnippet(),
            getDataOriginSetterSnippet({
                display: 'inline',
            }),
            getRequestConfigSetterSnippet({
                condition: (prop) => {
                    return (condition(prop, 'CnAsyncSelect', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') === 'request');
                },
            }, {
                position,
            }),
            {
                name: 'dataSource',
                title: '编辑静态数据',
                display: 'plain',
                tip: '编辑静态展示数据',
                setter: getStaticDataSourceSnippet(),
                condition(prop) {
                    return (condition(prop, 'CnAsyncSelect', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') !== 'request');
                },
            },
            {
                name: 'manual',
                title: '初始不请求',
                display: 'inline',
                defaultValue: false,
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            { title: '是', value: true },
                            { title: '否', value: false },
                        ],
                    },
                },
            },
            getRequestWhenFocusSetterSnippet(),
            getSearchRemoteSetterSnippet(),
            {
                name: 'searchKey',
                title: '远程搜索时的key',
                display: 'inline',
                setter: 'StringSetter',
                condition(prop) {
                    return (condition(prop, 'CnAsyncSelect', 'componentName') &&
                        prop?.parent?.getPropValue?.('searchRemote') === true);
                },
            },
            {
                name: 'useDetailValue',
                title: '使用详细数据 ',
                display: 'inline',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            { title: '是', value: true },
                            { title: '否', value: false },
                            { title: '不设置' },
                        ],
                    },
                },
            },
            // {
            //   name: 'hasSelectAll',
            //   title: '支持全选',
            //   display: 'inline',
            //   setter: {
            //     componentName: 'RadioGroupSetter',
            //     props: {
            //       options: [
            //         { title: '是', value: true },
            //         { title: '否', value: false },
            //         { title: '不设置' },
            //       ],
            //     },
            //   },
            //   condition(prop) {
            //     return (
            //       condition(prop, 'CnAsyncSelect', 'componentName') &&
            //       prop?.parent?.getPropValue?.('mode') === 'multiple'
            //     );
            //   },
            // },
            //       {
            //         title: '多选时的额外配置项',
            //         name: 'multipleExtraProps',
            //         display: 'accordion',
            //         setter: {
            //           componentName: 'ObjectSetter',
            //           props: {
            //             config: {
            //               items: [
            //                 {
            //                   name: 'initRequestConfig',
            //                   title: '多选时，初始化回显数据的API',
            //                   display: 'inline',
            //                   setter: {
            //                     componentName: 'ServiceChoiceSetter',
            //                     props: {
            //                       paramTitleDom: <div className=''>请求参数配置：</div>,
            //                       responseDom: (
            //                         <div style={{ paddingTop: '10px' }}>
            //                           请求返回结果的数据结构：
            //                           <a
            //                             target={'_blank'}
            //                             href='https://yuque.antfin.com/cn-framework-committee/cn-ui-data-structure/cn-async-select#iEuF0'
            //                           >
            //                             接口文档
            //                           </a>{' '}
            //                           <CnTooltip v2 align={'t'} trigger={<a>接口预览</a>}>
            //                             <div style={{ width: '200px', height: '260px' }}>
            //                               <img
            //                                 style={{ width: '100%' }}
            //                                 src='https://img.alicdn.com/imgextra/i1/O1CN01W5SNFR25Fg4QyRC53_!!6000000007497-0-tps-456-570.jpg'
            //                               />
            //                             </div>
            //                           </CnTooltip>
            //                         </div>
            //                       ),
            //                       buttonText: '选择请求API',
            //                       params: {
            //                         env: 'pre',
            //                         pageSize: 999,
            //                         // serviceType: 'HSF',
            //                       },
            //                       paramSetter: {
            //                         componentName: 'MixedSetter',
            //                         props: {
            //                           setters: [
            //                             paramSelectSetter,
            //                             {
            //                               componentName: 'StringSetter',
            //                               title: '字符串',
            //                             },
            //                             getJSExpressionPrototype({ type: 'formRequest' }),
            //                           ],
            //                         },
            //                       },
            //                       resultProcessFuncTemplate: `function(res) {
            //   // 需要返回的如下的数据结构
            //   // return {
            //   //   success: true,
            //   //   data: [
            //   //     {
            //   //        label:"xx",
            //   //        value:"xx",
            //   //     }
            //   //   ]
            //   // }
            //  return res;
            // }`,
            //                     },
            //                   },
            //                   // condition(prop) {
            //                   //   return condition(prop, 'CnAsyncSelect', 'componentName') && prop?.parent?.getPropValue?.('mode') === 'multiple';
            //                   // },
            //                 },
            //                 {
            //                   name: 'searchKey',
            //                   title: '远程搜索时的key',
            //                   display: 'inline',
            //                   setter: {
            //                     componentName: 'StringSetter',
            //                     props: {},
            //                   },
            //                 },
            //                 {
            //                   name: 'hideMaxTag',
            //                   title: '隐藏已选项数',
            //                   display: 'inline',
            //                   setter: 'BoolSetter',
            //                 },
            //               ],
            //             },
            //           },
            //         },
            //         condition(prop) {
            //           return (
            //             condition(prop, 'CnAsyncSelect', 'componentName') &&
            //             prop?.parent?.getPropValue?.('mode') === 'multiple'
            //           );
            //         },
            //       },
        ];
    },
};
export default Select;
